import {pathOr} from 'ramda'

export const megaMenu = pathOr(
  {
    "backButtonLabel": 'Retour',
    "corporateMenu": {
        "50000 Corporate memu item 1 menu_link_content:bfc1dc18-6f55-410f-966c-5c815f5b45d4": {
          "title": "Corporate memu item 1",
          "url": "http://adagio.loc/fr/aide-contact.shtml",
          "isExpanded": false,
          "inActiveTrail": false,
          "subtree": [],
          "preselected": false,
          "obfuscate": false,
          "obfuscateDataUrl": "",
          "disableForLanguage": false,
          "attributes": {
            "class": "",
            "target": ""
          },
        },
        "50000 Corporate-links 2 menu_link_content:68f3a240-46e8-4fe6-a0f2-1d1c842bed3f": {
          "title": "Corporate-links 2",
          "url": "http://adagio.loc/fr/loyalty-program-accor.shtml",
          "isExpanded": false,
          "inActiveTrail": false,
          "subtree": [],
          "preselected": false,
          "obfuscate": true,
          "obfuscateDataUrl": "aHR0cDovL2FkYWdpby5sb2MvZnIvbG95YWx0eS1wcm9ncmFtLWFjY29yLnNodG1s",
          "disableForLanguage": false,
          "attributes": {
            "class": "",
            "target": ""
          },
        }
      },
    "destinationsMenu": {
      "title": "Destinations",
      "subtree": {
        "0": {
          "title": "All destinations",
          "subtree": [],
          "url": "http://adagio.loc/fr/destinations.shtml",
          "preselected": false,
          "obfuscate": true,
          "obfuscateDataUrl": "aHR0cDovL2FkYWdpby5sb2MvZnIvZGVzdGluYXRpb25zLnNodG1s",
          "imagesBlock": [],
          "weight": 0
        },
        "93": {
          "title": "Top Destinations",
          "subtree": {
            "161_Strasbourg": {
              "count": 2,
              "parenTid": 93,
              "tid": "161",
              "title": "Strasbourg",
              "url": "http://adagio.loc/fr/apparthotel-strasbourg.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "199_Edimbourg": {
              "count": 1,
              "parenTid": 93,
              "tid": "199",
              "title": "Edimbourg",
              "url": "http://adagio.loc/fr/apparthotel-edimbourg.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "200_Rome": {
              "count": 1,
              "parenTid": 93,
              "tid": "200",
              "title": "Rome",
              "url": "http://adagio.loc/fr/apparthotel-rome.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "153_Paris": {
              "count": 17,
              "parenTid": 93,
              "tid": "153",
              "title": "Paris",
              "url": "http://adagio.loc/fr/apparthotel-paris.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            }
          },
          "preselected": true,
          "imagesBlock": {
            "images": [
              {
                "link": "https://www.google.com/",
                "imageSubTitle": "Top Destinations",
                "imageTitle": "<p>Top Destinations1</p>\r\n",
                "alt": "asd",
                "title": "asd",
                "width": "220",
                "height": "220",
                "url": "https://placekitten.com/220/220"
              },
              {
                "link": "https://www.google.com/",
                "imageSubTitle": "Top Destinations",
                "imageTitle": "<p>Top Destinations2</p>\r\n",
                "alt": "asd",
                "title": "asd",
                "width": "220",
                "height": "220",
                "url": "https://placekitten.com/220/220"
              }
            ]
          },
          "weight": "1"
        },
        "94_France": {
          "title": "France",
          "preselected": true,
          "subtree": {
            "130_Normandie": {
              "count": 2,
              "parenTid": 94,
              "tid": "130",
              "title": "Normandie",
              "url": "http://adagio.loc/fr/apparthotel-normandie.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": "",
              "imagesBlock": {
                "images": [
                  {
                    "link": "https://www.google.com/",
                    "imageSubTitle": "Top Destinations",
                    "imageTitle": "<p>Normandie img</p>\r\n",
                    "alt": "asd",
                    "title": "asd",
                    "width": "220",
                    "height": "220",
                    "url": "https://placekitten.com/220/220"
                  },
                  {
                    "link": "https://www.google.com/",
                    "imageSubTitle": "Top Destinations",
                    "imageTitle": "<p>Normandie img</p>\r\n",
                    "alt": "asd",
                    "title": "asd",
                    "width": "220",
                    "height": "220",
                    "url": "https://placekitten.com/220/220"
                  }
                ]
              },
            },
            "134_Nord": {
              "count": 2,
              "parenTid": 94,
              "tid": "134",
              "title": "Nord",
              "url": "http://adagio.loc/fr/apparthotel-nord.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "123_Midi Pyrénées": {
              "count": 3,
              "parenTid": 94,
              "tid": "123",
              "title": "Midi Pyrénées",
              "url": "http://adagio.loc/fr/apparthotel-midi-pyrenees.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "136_Lorraine": {
              "count": 1,
              "parenTid": 94,
              "tid": "136",
              "title": "Lorraine",
              "url": "http://adagio.loc/fr/apparthotel-lorraine.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "121_Languedoc Roussillon": {
              "count": 1,
              "parenTid": 94,
              "tid": "121",
              "title": "Languedoc Roussillon",
              "url": "http://adagio.loc/fr/apparthotel-languedoc-roussillon.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "125_Rhone Alpes": {
              "count": 3,
              "parenTid": 94,
              "tid": "125",
              "title": "Rhone Alpes",
              "url": "http://adagio.loc/fr/apparthotel-rhone-alpes.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "122_Poitou-Charentes": {
              "count": 1,
              "parenTid": 94,
              "tid": "122",
              "title": "Poitou-Charentes",
              "url": "http://adagio.loc/fr/apparthotel-poitou-charentes.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "126_Pays de la Loire": {
              "count": 2,
              "parenTid": 94,
              "tid": "126",
              "title": "Pays de la Loire",
              "url": "http://adagio.loc/fr/apparthotel-pays-de-la-loire.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "132_Bretagne": {
              "count": 1,
              "parenTid": 94,
              "tid": "132",
              "title": "Bretagne",
              "url": "http://adagio.loc/fr/apparthotel-bretagne.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "124_Ile de france": {
              "count": 39,
              "parenTid": 94,
              "tid": "124",
              "title": "Ile de france",
              "url": "http://adagio.loc/fr/apparthotel-ile-de-france.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "133_Centre": {
              "count": 2,
              "parenTid": 94,
              "tid": "133",
              "title": "Centre",
              "url": "http://adagio.loc/fr/apparthotel-centre.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "135_Bourgogne": {
              "count": 1,
              "parenTid": 94,
              "tid": "135",
              "title": "Bourgogne",
              "url": "http://adagio.loc/fr/apparthotel-bourgogne.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "127_Aquitaine": {
              "count": 2,
              "parenTid": 94,
              "tid": "127",
              "title": "Aquitaine",
              "url": "http://adagio.loc/fr/apparthotel-aquitaine.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "129_Alsace": {
              "count": 4,
              "parenTid": 94,
              "tid": "129",
              "title": "Alsace",
              "url": "http://adagio.loc/fr/apparthotel-alsace.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            }
          },
          "imagesBlock": {
            "images": [
              {
                "link": "https://www.google.com/",
                "imageSubTitle": "Top Destinations",
                "imageTitle": "<p>TFrance img</p>\r\n",
                "alt": "asd",
                "title": "asd",
                "width": "220",
                "height": "220",
                "url": "https://placekitten.com/220/220"
              },
              {
                "link": "https://www.google.com/",
                "imageSubTitle": "Top Destinations",
                "imageTitle": "<p>France img</p>\r\n",
                "alt": "asd",
                "title": "asd",
                "width": "220",
                "height": "220",
                "url": "https://placekitten.com/220/220"
              }
            ]
          },
          "weight": "2"
        },
        "95_Europe": {
          "title": "Europe",
          "subtree": {
            "909_Brême": {
              "count": 1,
              "parenTid": 95,
              "tid": "909",
              "title": "Brême",
              "url": "http://adagio.loc/fr/apparthotel-bremen.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "932_Malte": {
              "count": 1,
              "parenTid": 95,
              "tid": "932",
              "title": "Malte",
              "url": "http://adagio.loc/fr/malte.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "112_Suisse": {
              "count": 2,
              "parenTid": 95,
              "tid": "112",
              "title": "Suisse",
              "url": "http://adagio.loc/fr/apparthotel-suisse.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "120_Pays-Bas": {
              "count": 1,
              "parenTid": 95,
              "tid": "120",
              "title": "Pays-Bas",
              "url": "http://adagio.loc/fr/apparthotel-pays-bas.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "119_Italie": {
              "count": 1,
              "parenTid": 95,
              "tid": "119",
              "title": "Italie",
              "url": "http://adagio.loc/fr/apparthotel-italie.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "114_Belgique": {
              "count": 2,
              "parenTid": 95,
              "tid": "114",
              "title": "Belgique",
              "url": "http://adagio.loc/fr/apparthotel-belgique.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "113_Autriche": {
              "count": 1,
              "parenTid": 95,
              "tid": "113",
              "title": "Autriche",
              "url": "http://adagio.loc/fr/apparthotel-autriche.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "118_Ecosse": {
              "count": 1,
              "parenTid": 95,
              "tid": "118",
              "title": "Ecosse",
              "url": "http://adagio.loc/fr/apparthotel-ecosse.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            }
          },
          "preselected": false,
          "imagesBlock": [],
          "weight": "3"
        },
        "96_Reste du monde": {
          "title": "Reste du monde",
          "subtree": {
            "903_Maroc": {
              "count": 2,
              "parenTid": 96,
              "tid": "903",
              "title": "Maroc",
              "url": "http://adagio.loc/fr/apparthotel-maroc.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "117_Russie": {
              "count": 2,
              "parenTid": 96,
              "tid": "117",
              "title": "Russie",
              "url": "http://adagio.loc/fr/apparthotel-russie.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "110_Brésil": {
              "count": 9,
              "parenTid": 96,
              "tid": "110",
              "title": "Brésil",
              "url": "http://adagio.loc/fr/apparthotel-bresil.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            },
            "116_Emirats Arabes Unis": {
              "count": 3,
              "parenTid": 96,
              "tid": "116",
              "title": "Emirats Arabes Unis",
              "url": "http://adagio.loc/fr/apparthotel-emirats-arabes-unis.shtml",
              "subtree": [],
              "obfuscate": false,
              "obfuscateDataUrl": ""
            }
          },
          "preselected": false,
          "imagesBlock": [],
          "weight": "4"
        }
      }
    },
    "leftMenu": {
      "49951 Families menu_link_content:48b48986-bf8c-45ab-b124-77792c3321c0": {
        "title": "Families",
        "url": "http://adagio.loc/fr/sejours-en-famille.shtml",
        "isExpanded": false,
        "inActiveTrail": false,
        "subtree": [],
        "preselected": false,
        "obfuscate": true,
        "obfuscateDataUrl": "aHR0cDovL2FkYWdpby5sb2MvZnIvc2Vqb3Vycy1lbi1mYW1pbGxlLnNodG1s",
        "disableForLanguage": false,
        "attributes": [],
        "imagesBlock": []
      },
      "49952 Offers and promotions menu_link_content:6a22e69c-5a10-4e36-97d6-a99e2146df91": {
        "title": "Offers and promotions",
        "url": "http://adagio.loc/fr/hotel-6448-aparthotel-adagio-nantes-centre/index.shtml",
        "isExpanded": true,
        "inActiveTrail": false,
        "subtree": {
          "49950 Coliving menu_link_content:41a691b7-8058-4c3e-b908-33b09292576d": {
            "title": "Coliving",
            "url": "http://adagio.loc/fr/hotel-9939-aparthotel-adagio-frankfurt-city-messe/index.shtml",
            "isExpanded": false,
            "inActiveTrail": false,
            "subtree": [],
            "preselected": false,
            "obfuscate": false,
            "obfuscateDataUrl": "",
            "disableForLanguage": false,
            "attributes": [],
            "imagesBlock": []
          },
          "49951 Découvrir Adagio menu_link_content:556ffd06-fec9-4398-8943-528ef841959d": {
            "title": "Découvrir Adagio",
            "url": "http://adagio.loc/long-stay",
            "isExpanded": false,
            "inActiveTrail": false,
            "subtree": [],
            "preselected": false,
            "obfuscate": false,
            "obfuscateDataUrl": "",
            "disableForLanguage": false,
            "attributes": [],
            "imagesBlock": []
          },
          "49951 Early booking rate menu_link_content:82148a7a-75d1-4b9e-acd5-13b27c4d7746": {
            "title": "Early booking rate",
            "url": "http://adagio.loc/fr/hotel-9352-adagio-sao-paulo-barra-funda/index.shtml",
            "isExpanded": false,
            "inActiveTrail": false,
            "subtree": [],
            "preselected": false,
            "obfuscate": false,
            "obfuscateDataUrl": "",
            "disableForLanguage": false,
            "attributes": {
              "class": "",
              "target": ""
            },
            "imagesBlock": []
          },
          "49953 Promos menu_link_content:7d124cef-54d5-4a32-b744-b98b0e901756": {
            "title": "Promos",
            "url": "http://adagio.loc/fr/offres/index.shtml",
            "isExpanded": false,
            "inActiveTrail": false,
            "subtree": {
              "0": {
                "title": "Promo Second level1",
                "url": "http://adagio.loc/fr/hotel-9939-aparthotel-adagio-frankfurt-city-messe/index.shtml",
                "isExpanded": true,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": true,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": true,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjour menu_link_content:5cb22a51-135b-4ffc-a2ec-960ca76c508e": {
                "title": "Promo Long séjour 2",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjour menu_link_content:5cb22a5135b-4ffc-a2ec-960ca7c508e": {
                "title": "Promo Long séjour 3",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjour menu_link_content:522a51-135bffc-a2ec-960ca7c508e": {
                "title": "Promo Long séjour 4",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjour menu_linkcontent:5a51-135b-4ffc-a2ec-960ca7c508e": {
                "title": "Promo Long séjourv 5",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjour menu_link_content:5cb2251-135bffc-a2ec-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjour menu_link_content:b22a51-135b-4ffc-a2ec-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjour menu_link_content:5cb22a51-135b-4ffa2ec-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjour menu_link_conte:5cb22a51-135b-4ffc-a2ec-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "490 Long séjour menu_link_content5cb22a51-135b-4ffc-a2ec-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjour menu_link_content:5cb22a513b-4ffc-a2ec-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Lonséjour menu_link_connt:5cb22a51-13b-4ffc-a2c-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjour:5cb22a51-15b-4ff-a2ec-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 ng séjour menu_link_content:5cb22a51-15b-4ffc-a2ec-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Lonséjour menu_link_content:5cb2251-135bffc-a2ec-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjoumenu_link_content:b22a51-135b-4ffc-a2ec-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjour me_link_content:5cb22a51-135b-4ffa2ec-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjour menu_li_conte:5cb22a51-135b-4ffc-a2ec-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
            },
            "imagesBlock": {
              "images": [
                {
                  "link": "http://adagio.loc/fr/apparthotel-paris.shtml",
                  "imageSubTitle": "Subtitle",
                  "imageTitle": "<p>Megamenu image title Promos</p>\r\n",
                  "alt": "asd",
                  "title": "asd",
                  "width": "220",
                  "height": "135",
                  "url": "https://placekitten.com/220/220",
                }
              ],
            },
            "preselected": true,
            "obfuscate": false,
            "obfuscateDataUrl": "",
            "disableForLanguage": false,
            "attributes": {
              "class": "",
              "target": ""
            },
          },
          "49953 Second level menu_link_content:df70ede0-6bdc-4f17-acd9-0dd18e5f849b": {
            "title": "Second level",

            "subtree": {
              "0": {
                "title": "Second level",
                "url": "http://adagio.loc/fr/hotel-9939-aparthotel-adagio-frankfurt-city-messe/index.shtml",
                "isExpanded": true,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": true,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": {
                  "images": [
                    {
                      "link": "http://adagio.loc/fr/apparthotel-paris.shtml",
                      "imageSubTitle": "Subtitle",
                      "imageTitle": "<p>Second level</p>\r\n",
                      "alt": "asd",
                      "title": "asd",
                      "width": "220",
                      "height": "135",
                      "url": "https://placekitten.com/220/220",
                    }
                  ],
                },
              },
              "49950 Long séjour menu_link_content:5cb22a51-135b-4ffc-a2ec-960ca76c508e": {
                "title": "Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              }
            },

          },
        },
        "preselected": false,
        "obfuscate": false,
        "obfuscateDataUrl": "",
        "disableForLanguage": false,
        "attributes": [],
        "imagesBlock": {
          "images": [
            {
              "link": "http://adagio.loc/fr/apparthotel-paris.shtml",
              "imageSubTitle": "Subtitle",
              "imageTitle": "<p>Megamenu image title</p>\r\n",
              "alt": "asd",
              "title": "asd",
              "width": "220",
              "height": "135",
              "url": "https://placekitten.com/220/220",
            },
            {
              "link": "http://adagio.loc/fr/apparthotel-paris.shtml",
              "imageSubTitle": "Subtitle",
              "imageTitle": "<p>Megamenu image title</p>\r\n",
              "alt": "asd",
              "title": "asd",
              "width": "220",
              "height": "135",
              "url": "https://placekitten.com/220/220",
            }
          ],
        },
      },
      "49952 Professionals menu_link_content:2dcefaf9-0cab-490e-9a34-355179a2e745": {
        "title": "Professials item with a very long title",
        "url": "http://adagio.loc/fr/long-stay/30days.shtml",
        "isExpanded": true,
        "inActiveTrail": false,
        "subtree": {
          "49950 Coliving menu_link_content:41a691b7-8058-4c3e-b908-33b09292576d": {
            "title": "Coliving",
            "url": "http://adagio.loc/fr/hotel-9939-aparthotel-adagio-frankfurt-city-messe/index.shtml",
            "isExpanded": false,
            "inActiveTrail": false,
            "subtree": [],
            "preselected": false,
            "obfuscate": false,
            "obfuscateDataUrl": "",
            "disableForLanguage": false,
            "attributes": [],
            "imagesBlock": []
          },
          "49951 Découvrir Adagio menu_link_content:556ffd06-fec9-4398-8943-528ef841959d": {
            "title": "Découvrir Adagio",
            "url": "http://adagio.loc/long-stay",
            "isExpanded": false,
            "inActiveTrail": false,
            "subtree": [],
            "preselected": false,
            "obfuscate": false,
            "obfuscateDataUrl": "",
            "disableForLanguage": false,
            "attributes": [],
            "imagesBlock": []
          },
          "49951 Early booking rate menu_link_content:82148a7a-75d1-4b9e-acd5-13b27c4d7746": {
            "title": "Early booking rate",
            "url": "http://adagio.loc/fr/hotel-9352-adagio-sao-paulo-barra-funda/index.shtml",
            "isExpanded": false,
            "inActiveTrail": false,
            "subtree": [],
            "preselected": false,
            "obfuscate": false,
            "obfuscateDataUrl": "",
            "disableForLanguage": false,
            "attributes": {
              "class": "",
              "target": ""
            },
            "imagesBlock": []
          },
          "49953 Promos menu_link_content:7d124cef-54d5-4a32-b744-b98b0e901756": {
            "title": "Promos",
            "url": "http://adagio.loc/fr/offres/index.shtml",
            "isExpanded": false,
            "inActiveTrail": false,
            "subtree": {
              "0": {
                "title": "Promo Second level1",
                "url": "http://adagio.loc/fr/hotel-9939-aparthotel-adagio-frankfurt-city-messe/index.shtml",
                "isExpanded": true,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": true,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjour menu_link_content:5cb22a51-135b-4ffc-a2ec-960ca76c508e": {
                "title": "Promo Long séjour 2",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjour menu_link_content:5cb22a5135b-4ffc-a2ec-960ca7c508e": {
                "title": "Promo Long séjour 3",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjour menu_link_content:522a51-135bffc-a2ec-960ca7c508e": {
                "title": "Promo Long séjour 4",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjour menu_linkcontent:5a51-135b-4ffc-a2ec-960ca7c508e": {
                "title": "Promo Long séjourv 5",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjour menu_link_content:5cb2251-135bffc-a2ec-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjour menu_link_content:b22a51-135b-4ffc-a2ec-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjour menu_link_content:5cb22a51-135b-4ffa2ec-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjour menu_link_conte:5cb22a51-135b-4ffc-a2ec-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "490 Long séjour menu_link_content5cb22a51-135b-4ffc-a2ec-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjour menu_link_content:5cb22a513b-4ffc-a2ec-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Lonséjour menu_link_connt:5cb22a51-13b-4ffc-a2c-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjour:5cb22a51-15b-4ff-a2ec-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 ng séjour menu_link_content:5cb22a51-15b-4ffc-a2ec-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Lonséjour menu_link_content:5cb2251-135bffc-a2ec-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjoumenu_link_content:b22a51-135b-4ffc-a2ec-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjour me_link_content:5cb22a51-135b-4ffa2ec-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
              "49950 Long séjour menu_li_conte:5cb22a51-135b-4ffc-a2ec-960ca7c508e": {
                "title": "Promo Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              },
            },
            "imagesBlock": {
              "images": [
                {
                  "link": "http://adagio.loc/fr/apparthotel-paris.shtml",
                  "imageSubTitle": "Subtitle",
                  "imageTitle": "<p>Megamenu image title Promos</p>\r\n",
                  "alt": "asd",
                  "title": "asd",
                  "width": "220",
                  "height": "135",
                  "url": "https://placekitten.com/220/220",
                }
              ],
            },
            "preselected": false,
            "obfuscate": false,
            "obfuscateDataUrl": "",
            "disableForLanguage": false,
            "attributes": {
              "class": "",
              "target": ""
            },
          },
          "49953 Second level menu_link_content:df70ede0-6bdc-4f17-acd9-0dd18e5f849b": {
            "title": "Second level",

            "subtree": {
              "0": {
                "title": "Second level",
                "url": "http://adagio.loc/fr/hotel-9939-aparthotel-adagio-frankfurt-city-messe/index.shtml",
                "isExpanded": true,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": true,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": {
                  "images": [
                    {
                      "link": "http://adagio.loc/fr/apparthotel-paris.shtml",
                      "imageSubTitle": "Subtitle",
                      "imageTitle": "<p>Second level</p>\r\n",
                      "alt": "asd",
                      "title": "asd",
                      "width": "220",
                      "height": "135",
                      "url": "https://placekitten.com/220/220",
                    }
                  ],
                },
              },
              "49950 Long séjour menu_link_content:5cb22a51-135b-4ffc-a2ec-960ca76c508e": {
                "title": "Long séjour",
                "url": "http://adagio.loc/fr/long-stay/form.shtml",
                "isExpanded": false,
                "inActiveTrail": false,
                "subtree": [],
                "preselected": false,
                "obfuscate": false,
                "obfuscateDataUrl": "",
                "disableForLanguage": false,
                "attributes": [],
                "imagesBlock": []
              }
            },

          },
        },
        "preselected": false,
        "obfuscate": false,
        "obfuscateDataUrl": "",
        "disableForLanguage": false,
        "attributes": [],
        "imagesBlock": {
          "images": [
            {
              "link": "http://adagio.loc/fr/apparthotel-paris.shtml",
              "imageSubTitle": "Subtitle",
              "imageTitle": "<p>Megamenu image title</p>\r\n",
              "alt": "asd",
              "title": "asd",
              "width": "220",
              "height": "135",
              "url": "https://placekitten.com/220/220",
            },
            {
              "link": "http://adagio.loc/fr/apparthotel-paris.shtml",
              "imageSubTitle": "Subtitle",
              "imageTitle": "<p>Megamenu image title</p>\r\n",
              "alt": "asd",
              "title": "asd",
              "width": "220",
              "height": "135",
              "url": "https://placekitten.com/220/220",
            }
          ],
        },
      }
    },
    "rightMenu": {
      "49950 Familles menu_link_content:ac838e99-20b5-411b-aa6c-f52a338c7b91": {
        "title": "Familles and  Coliving",
        "url": "http://adagio.loc/fr/sejours-en-famille.shtml",
        "isExpanded": false,
        "inActiveTrail": false,
        "subtree": {
          "49950 Familles menu_link_content:41a691b7-8058-4c3e-b908-33b09292576d": {
            "title": "Second lvl Familles",
            "url": "http://adagio.loc/fr/hotel-9939-aparthotel-adagio-frankfurt-city-messe/index.shtml",
            "isExpanded": false,
            "inActiveTrail": false,
            "subtree": [],
            "preselected": false,
            "obfuscate": false,
            "obfuscateDataUrl": "",
            "disableForLanguage": false,
            "attributes": [],
            "imagesBlock": {
              "images": [
                {
                  "imageSubTitle": "Subtitle",
                  "imageTitle": "<p>Megamenu image title</p>\r\n",
                  "alt": "asd",
                  "title": "asd",
                  "width": "220",
                  "height": "135",
                  "url": "https://placekitten.com/220/220",
                },
                {
                  "link": "http://adagio.loc/fr/apparthotel-paris.shtml",
                  "imageSubTitle": "Subtitle",
                  "imageTitle": "<p>Megamenu image title</p>\r\n",
                  "alt": "asd",
                  "title": "asd",
                  "width": "220",
                  "height": "135",
                  "url": "https://placekitten.com/220/220",
                }
              ],
            },
          },
          "49951 Découvrir Adagio menu_link_conten": {
            "title": "Découvrir Adagio",
            "url": "http://adagio.loc/long-stay",
            "isExpanded": false,
            "inActiveTrail": false,
            "subtree": [],
            "preselected": false,
            "obfuscate": false,
            "obfuscateDataUrl": "",
            "disableForLanguage": false,
            "attributes": [],
            "imagesBlock": []
          },
        },
        "preselected": false,
        "obfuscate": false,
        "obfuscateDataUrl": "",
        "disableForLanguage": false,
        "attributes": [],
        "imagesBlock": {
          "images": [
            {
              "link": "http://adagio.loc/fr/apparthotel-paris.shtml",
              "imageSubTitle": "Subtitle",
              "imageTitle": "<p>Megamenu image title</p>\r\n",
              "alt": "asd",
              "title": "asd",
              "width": "220",
              "height": "135",
              "url": "https://placekitten.com/220/220",
            },
            {
              "link": "http://adagio.loc/fr/apparthotel-paris.shtml",
              "imageSubTitle": "Subtitle",
              "imageTitle": "<p>Megamenu image title</p>\r\n",
              "alt": "asd",
              "title": "asd",
              "width": "220",
              "height": "135",
              "url": "https://placekitten.com/220/220",
            }
          ],
        },
      },
      "49950 Familles menu_link_content:ac838e99-20b5-411b-aa6c-f52a337b91": {
        "title": "Legal",
        "url": "http://adagio.loc/fr/sejours-en-famille.shtml",
        "isExpanded": false,
        "inActiveTrail": false,
        "subtree": {
          "49950 Coliving menu_link_content:41a691b7-8058-4c3e-b908-33b09292576d": {
            "title": "Coliving",
            "url": "http://adagio.loc/fr/hotel-9939-aparthotel-adagio-frankfurt-city-messe/index.shtml",
            "isExpanded": false,
            "inActiveTrail": false,
            "subtree": [],
            "preselected": false,
            "obfuscate": false,
            "obfuscateDataUrl": "",
            "disableForLanguage": false,
            "attributes": [],
            "imagesBlock": []
          },
          "49951 Découvrir Adagio menu_link_conten": {
            "title": "Découvrir Adagio",
            "url": "http://adagio.loc/long-stay",
            "isExpanded": false,
            "inActiveTrail": false,
            "subtree": [],
            "preselected": false,
            "obfuscate": false,
            "obfuscateDataUrl": "",
            "disableForLanguage": false,
            "attributes": [],
            "imagesBlock": []
          },
        },
        "preselected": false,
        "obfuscate": false,
        "obfuscateDataUrl": "",
        "disableForLanguage": false,
        "attributes": [],
        "imagesBlock": {
          "images": [
            {
              "imageSubTitle": "Subtitle",
              "imageTitle": "<p>Megamenu image title</p>\r\n",
              "alt": "asd",
              "title": "asd",
              "width": "220",
              "height": "135",
              "url": "https://placekitten.com/220/220",
            },
            {
              "link": "http://adagio.loc/fr/apparthotel-paris.shtml",
              "imageSubTitle": "Subtitle",
              "imageTitle": "<p>Megamenu image title</p>\r\n",
              "alt": "asd",
              "title": "asd",
              "width": "220",
              "height": "135",
              "url": "https://placekitten.com/220/220",
            }
          ],
        },
      }
    },
    "logoUrl": "https://www.adagio-city.com",
    "logoAlt": "Adagio Aparthotel",
    "logoAriaLabel": "Main"
  },
  ['drupalSettings', 'megaMenu'],
  window,
)

// "url": "https://www.adagio-city.com/sites/default/files/styles/banner/optimicdn/push_banner/item_image/2023-03/lyon5.jpeg?itok=9ZsQs6Fx&twic=v1/cover=220x220"


